import { TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

export const CustomTextField = ({
	name,
	label,
	control,
	errors,
	required = false,
	...props
}) => {
	return (
		<Controller
			name={name}
			control={control}
			rules={
				required
					? { required: `Enter ${label?.toLowerCase()}` }
					: undefined
			}
			defaultValue=""
			render={({ field }) => (
				<TextField
					{...field}
					inputRef={field.ref}
					fullWidth
					label={label}
					variant="outlined"
					error={Boolean(errors?.[name])}
					helperText={errors?.[name]?.message}
					{...props}
				/>
			)}
		/>
	);
};
